module.exports = __webpack_public_path__ + "img/learnModel-ball-sm-desktop.89e5562a.png";